import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
declare var Chart: any;


@Component({
  selector: 'app-file-management-route',
  standalone:false,
  templateUrl: './file-management-route.component.html',
  styleUrl: './file-management-route.component.scss'
})
export class FileManagementRouteComponent implements  OnInit, AfterViewInit {
  // Data subjects
  // private proposalsSubject = new BehaviorSubject<Proposal[]>(this.getMockProposals());
  private selectedProposalsSubject = new BehaviorSubject<Proposal[]>([]);
  private actionPointsSubject = new BehaviorSubject<ActionPoint[]>([]);
  private reviewActionPointsSubject = new BehaviorSubject<ReviewActionPoint[]>(this.getMockReviewActionPoints());
  // private reviewStatusSubject = new BehaviorSubject<ReviewStatus[]>(this.getMockReviewStatus());
  private dashboardStatsSubject = new BehaviorSubject<DashboardStats>(this.getMockDashboardStats());
  private upcomingReviewsSubject = new BehaviorSubject<UpcomingReview[]>(this.getMockUpcomingReviews());

  // Observables
  // proposals$ = this.proposalsSubject.asObservable();
  selectedProposals$ = this.selectedProposalsSubject.asObservable();
  actionPoints$ = this.actionPointsSubject.asObservable();
  reviewActionPoints$ = this.reviewActionPointsSubject.asObservable();
  // reviewStatus$ = this.reviewStatusSubject.asObservable();
  dashboardStats$ = this.dashboardStatsSubject.asObservable();
  upcomingReviews$ = this.upcomingReviewsSubject.asObservable();

  // Component state
  proposals: Proposal[] = [];
  selectedProposals: Proposal[] = [];
  dashboardStats: DashboardStats | null = null;
  upcomingReviews: UpcomingReview[] = [];
  actionPoints: ActionPoint[] = [];
  reviewActionPoints: ReviewActionPoint[] = [];
  // reviewStatus: ReviewStatus[] = [];
  directorates: Directorate[] = [];

  activeTab = 'dashboard';
  reviewDate = '2023-05-20';
  reviewType: ReviewType = ReviewType.INTERNAL_REVIEW;
  filterCriteria: string = 'all';
  searchTerm: string = '';
  filteredProposals: Proposal[] = [];
   reviewData: any;
  reviewOptions: any;
  displayReviewStatusDialog: boolean = false;
  selectedReviewStatus: DetailedReviewStatus | null = null;
  reviewStatusDialogHeader: string = 'Review Details';

  selectedUsers: User[] = [];
  selectedDirectorates: Directorate[] = [];
  internalUsers: User[] = [];
  externalDirectorates: Directorate[] = [];
  submissionInProgress: boolean = false;
    displayActionPointDialog: boolean = false;
  selectedActionPoint: ActionPointUpdate | null = null;
  actionPointDialogHeader: string = 'Update Action Point Status';
  
  // Status options for dropdown
  actionPointStatusOptions = [
    { label: 'Not Started', value: ActionPointStatus.NOT_STARTED },
    { label: 'In Progress', value: ActionPointStatus.IN_PROGRESS },
    { label: 'Completed', value: ActionPointStatus.COMPLETED },
    { label: 'On Hold', value: ActionPointStatus.ON_HOLD },
    { label: 'Cancelled', value: ActionPointStatus.CANCELLED }
  ];

  // Priority options
  priorityOptions = [
    { label: 'Low', value: ActionPointPriority.LOW },
    { label: 'Medium', value: ActionPointPriority.MEDIUM },
    { label: 'High', value: ActionPointPriority.HIGH },
    { label: 'Critical', value: ActionPointPriority.CRITICAL }
  ];

  // Progress options
  progressOptions = [
    { label: '0%', value: 0 },
    { label: '25%', value: 25 },
    { label: '50%', value: 50 },
    { label: '75%', value: 75 },
    { label: '100%', value: 100 }
  ];
    private nextActionPointId = 1;
      uploadedFiles: any[] = [];
      
 reviewStatus: any[] = [
    {
      srNo: 'PRJ-001',
      proposalName: 'Urban Infrastructure Development Project',
      reviewDate: '2024-02-15',
      reviewType: 'Internal Review',
      overallStatus: 'IN_PROGRESS',
      totalActionPoints: 12,
      completed: 5,
      inProgress: 4,
      pending: 3,
      summary: {
        total: 12,
        completed: 5,
        inProgress: 4,
        pending: 2,
        notStarted: 1
      },
      reviewPoints: [
        {
          id: 'RP-001',
          category: 'Technical',
          description: 'Review structural design specifications',
          assignedTo: 'Technical Directorate',
          dueDate: '2024-02-20',
          status: 'COMPLETED',
          lastUpdated: '2024-02-18',
          comments: 'All specifications reviewed and approved',
          attachments: [
            { name: 'design-specs.pdf', size: 2450000, type: 'application/pdf', uploadDate: '2024-02-18' },
            { name: 'structural-analysis.xlsx', size: 890000, type: 'application/vnd.ms-excel', uploadDate: '2024-02-18' }
          ],
          showFileUpload: false
        },
        {
          id: 'RP-002',
          category: 'Financial',
          description: 'Verify budget allocation and cost estimates',
          assignedTo: 'Financial Directorate',
          dueDate: '2024-02-25',
          status: 'IN_PROGRESS',
          lastUpdated: '2024-02-19',
          comments: '80% of budget reviewed, awaiting final figures',
          attachments: [
            { name: 'budget-breakdown.pdf', size: 1560000, type: 'application/pdf', uploadDate: '2024-02-19' }
          ],
          showFileUpload: false
        },
        {
          id: 'RP-003',
          category: 'Environmental',
          description: 'Environmental impact assessment review',
          assignedTo: 'Environmental Directorate',
          dueDate: '2024-03-01',
          status: 'PENDING',
          lastUpdated: '2024-02-15',
          comments: 'Assessment in progress',
          attachments: [],
          showFileUpload: false
        },
        {
          id: 'RP-004',
          category: 'Legal',
          description: 'Review compliance with local regulations',
          assignedTo: 'Legal Directorate',
          dueDate: '2024-02-28',
          status: 'IN_PROGRESS',
          lastUpdated: '2024-02-20',
          comments: 'Initial compliance check completed',
          attachments: [
            { name: 'compliance-report.docx', size: 450000, type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', uploadDate: '2024-02-20' }
          ],
          showFileUpload: false
        },
        {
          id: 'RP-005',
          category: 'Technical',
          description: 'Review material specifications and quality standards',
          assignedTo: 'Technical Directorate',
          dueDate: '2024-02-22',
          status: 'COMPLETED',
          lastUpdated: '2024-02-21',
          comments: 'All materials meet quality standards',
          attachments: [
            { name: 'material-specs.pdf', size: 3200000, type: 'application/pdf', uploadDate: '2024-02-21' },
            { name: 'quality-certificates.zip', size: 5400000, type: 'application/zip', uploadDate: '2024-02-21' }
          ],
          showFileUpload: false
        }
      ]
    },
    {
      srNo: 'PRJ-002',
      proposalName: 'Digital Transformation Initiative',
      reviewDate: '2024-02-10',
      reviewType: 'Joint Review with Nodal Directorate',
      overallStatus: 'COMPLETED',
      totalActionPoints: 8,
      completed: 8,
      inProgress: 0,
      pending: 0,
      summary: {
        total: 8,
        completed: 8,
        inProgress: 0,
        pending: 0,
        notStarted: 0
      },
      reviewPoints: [
        {
          id: 'RP-101',
          category: 'Technical',
          description: 'Review system architecture design',
          assignedTo: 'Technical Directorate',
          dueDate: '2024-02-15',
          status: 'COMPLETED',
          lastUpdated: '2024-02-14',
          comments: 'Architecture approved with minor modifications',
          attachments: [
            { name: 'system-architecture.pdf', size: 1890000, type: 'application/pdf', uploadDate: '2024-02-14' }
          ],
          showFileUpload: false
        },
        {
          id: 'RP-102',
          category: 'Financial',
          description: 'Review implementation cost estimates',
          assignedTo: 'Financial Directorate',
          dueDate: '2024-02-12',
          status: 'COMPLETED',
          lastUpdated: '2024-02-11',
          comments: 'Cost estimates verified and approved',
          attachments: [
            { name: 'cost-analysis.xlsx', size: 670000, type: 'application/vnd.ms-excel', uploadDate: '2024-02-11' },
            { name: 'budget-approval.pdf', size: 890000, type: 'application/pdf', uploadDate: '2024-02-11' }
          ],
          showFileUpload: false
        }
      ]
    },
    {
      srNo: 'PRJ-003',
      proposalName: 'Healthcare Infrastructure Upgrade',
      reviewDate: '2024-02-28',
      reviewType: 'Internal Review',
      overallStatus: 'NOT_STARTED',
      totalActionPoints: 15,
      completed: 0,
      inProgress: 0,
      pending: 15,
      summary: {
        total: 15,
        completed: 0,
        inProgress: 0,
        pending: 10,
        notStarted: 5
      },
      reviewPoints: [
        {
          id: 'RP-201',
          category: 'Technical',
          description: 'Review medical equipment specifications',
          assignedTo: 'Technical Directorate',
          dueDate: '2024-03-10',
          status: 'NOT_STARTED',
          lastUpdated: '2024-02-25',
          comments: 'Awaiting equipment specifications from vendor',
          attachments: [],
          showFileUpload: false
        },
        {
          id: 'RP-202',
          category: 'Financial',
          description: 'Review project funding allocation',
          assignedTo: 'Financial Directorate',
          dueDate: '2024-03-05',
          status: 'PENDING',
          lastUpdated: '2024-02-25',
          comments: 'Funding proposal under preparation',
          attachments: [],
          showFileUpload: false
        }
      ]
    }
  ];
    private subscriptions = new Subscription();
    totalRecords:number=0
  actionPointList: { edc: any; action_point: any; comment: any; directorate: any; flag: any; }[];
  constructor(
    private messageService: MessageService , 
    private api: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location
  ) {
    this.reviewData = {
      labels: ['Completed', 'In Progress', 'Pending', 'Not Started'],
      datasets: [
        {
          data: [12, 8, 5, 3],
          backgroundColor: ['#198754', '#FFC107', '#0DCAF0', '#6C757D'],
          hoverBackgroundColor: ['#14532D', '#FFB700', '#0AB9E0', '#495057']
        }
      ]
    };

    this.reviewOptions = {
      plugins: {
        legend: {
          position: 'bottom'
        }
      }
    };
  }

proposalId: any;
  ngOnInit(): void {
    this.getReviewList()
    // this.getActionPoint()
    this.getUnit()
    this.loadData();
    this.applyFilter();
     this.route.queryParams.subscribe(params => {
    this.proposalId = params['proposal_id'];
    
  });
  }

  ngAfterViewInit(): void {
    this.initializeChart();
  }

  private initializeChart(): void {
    setTimeout(() => {
      const ctx = document.getElementById('reviewChart');
      if (ctx) {
        new Chart(ctx, {
          type: 'doughnut',
          data: {
            labels: ['Completed', 'In Progress', 'Pending', 'Not Started'],
            datasets: [{
              data: [12, 8, 5, 3],
              backgroundColor: [
                '#10b981',
                '#3b82f6',
                '#f59e0b',
                '#6b7280'
              ],
              borderWidth: 1
            }]
          },
          options: {
            responsive: true,
            plugins: {
              legend: {
                position: 'bottom',
              }
            }
          }
        });
      }
    }, 100);
  }

  private loadData(): void {
    // this.proposals$.subscribe(proposals => {
    //   this.proposals = proposals;
    //   this.applyFilter(); // Reapply filter when proposals change
    // });

   this.selectedProposals$.subscribe(selected => {
  this.selectedProposals = selected;

  // initialize action point visibility
  this.selectedProposals.forEach(p => {
    p.showActionPoints = false;
  });

});

    this.dashboardStats$.subscribe(stats => {
      this.dashboardStats = stats;
    });

    this.upcomingReviews$.subscribe(reviews => {
      this.upcomingReviews = reviews;
    });

    this.actionPoints$.subscribe(points => {
      this.actionPoints = points;
    });

    this.reviewActionPoints$.subscribe(points => {
      this.reviewActionPoints = points;
    });

    // this.reviewStatus$.subscribe(status => {
    //   this.reviewStatus = status;
    // });

    this.directorates = this.getDirectorates();
  }

  // Filter Methods
  applyFilter(): void {
    let filtered = [...this.proposals];

    // Apply criteria filter
    if (this.filterCriteria !== 'all') {
      filtered = filtered.filter(proposal => {
        switch (this.filterCriteria) {
          case 'nearing-milestones':
            return proposal.selectionCriteria === SelectionCriteria.NEARING_MILESTONE;
          case 'review-not-done':
            return proposal.selectionCriteria === SelectionCriteria.REVIEW_NOT_DONE;
          case 'both-criteria':
            return proposal.selectionCriteria === SelectionCriteria.BOTH;
          default:
            return true;
        }
      });
    }

    // Apply search filter
    if (this.searchTerm) {
      const term = this.searchTerm.toLowerCase();
      filtered = filtered.filter(proposal =>
        proposal.proposal_name.toLowerCase().includes(term) ||
        proposal.description.toLowerCase().includes(term) ||
        proposal.srNo.toLowerCase().includes(term) ||
        proposal.closestMilestone.toLowerCase().includes(term)
      );
    }

    this.filteredProposals = filtered;
  }

  onFilterChange(criteria: string): void {
    this.filterCriteria = criteria;
    this.applyFilter();
  }

  onSearchChange(term: string): void {
    this.searchTerm = term;
    this.applyFilter();
  }

  // Enhanced selection methods that work with filtered data
  selectAllFilteredProposals(): void {
    // const currentProposals = this.proposalsSubject.value;
    // const filteredSrNos = this.filteredProposals.map(p => p.srNo);
    
    // const updatedProposals = currentProposals.map(p => 
    //   filteredSrNos.includes(p.srNo) ? { ...p, selected: true } : p
    // );
    
    // this.proposalsSubject.next(updatedProposals);
    this.updateSelectedProposals();
  }

  deselectAllFilteredProposals(): void {
    // const currentProposals = this.proposalsSubject.value;
    // const filteredSrNos = this.filteredProposals.map(p => p.srNo);
    
    // const updatedProposals = currentProposals.map(p => 
    //   filteredSrNos.includes(p.srNo) ? { ...p, selected: false } : p
    // );
    
    // this.proposalsSubject.next(updatedProposals);
    // this.updateSelectedProposals();
  }

// Helper method to get display name for filter
getFilterDisplayName(criteria: string): string {
  const filterNames: { [key: string]: string } = {
    'all': 'All Proposals',
    'nearing-milestones': 'Nearing Milestones',
    'review-not-done': 'Review Not Done',
    'both-criteria': 'Both Criteria'
  };
  return filterNames[criteria] || criteria;
}

// Clear all filters
clearFilters(): void {
  this.filterCriteria = 'all';
  this.searchTerm = '';
  this.applyFilter();
}

  private updateSelectedProposals(): void {
    // const proposals = this.proposalsSubject.value;
    // const selected = proposals.filter(p => p.selected);
    // this.selectedProposalsSubject.next(selected);
  }

  // Navigation methods
  proceedToReview(): void {
    if (this.selectedProposals.length > 0) {
      this.activeTab = 'send';
    } else {
      alert('Please select at least one proposal to proceed.');
    }
  }

  backToDashboard(): void {
    this.activeTab = 'dashboard';
  }

  setActiveTab(tab: string): void {
    this.activeTab = tab;
  }

  // Utility methods
  getBadgeClass(daysRemaining: number): string {
    if (daysRemaining <= 5) return 'bg-danger';
    if (daysRemaining <= 15) return 'bg-warning';
    return 'bg-success';
  }

  getCriteriaBadgeClass(criteria: string): string {
    switch (criteria) {
      case 'Nearing Milestone': return 'bg-primary';
      case 'Review Not Done': return 'bg-warning';
      case 'Both': return 'bg-danger';
      default: return 'bg-secondary';
    }
  }
  formatDate(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB');
  }

  // Data methods (formerly in service)
  private getDirectorates(): Directorate[] {
    return [
      { id: '1', name: 'Directorate A' },
      { id: '2', name: 'Directorate B' },
      { id: '3', name: 'Directorate C' },
      { id: '4', name: 'EDC' },
      { id: '5', name: 'DOI' }
    ];
  }

  // private getMockProposals(): Proposal[] {
  //   return [
  //     {
  //       srNo: 'PR-2023-001',
  //       name: 'Advanced Communication System',
  //       description: 'Development of next-gen military comm system',
  //       lastReview: '15 Mar 2023',
  //       closestMilestone: 'Prototype Testing',
  //       daysRemaining: 12,
  //       selectionCriteria: SelectionCriteria.NEARING_MILESTONE,
  //       selected: false
  //     },
  //     {
  //       srNo: 'PR-2023-002',
  //       name: 'AI-based Surveillance',
  //       description: 'AI-powered border surveillance system',
  //       lastReview: '22 Feb 2023',
  //       closestMilestone: 'Algorithm Optimization',
  //       daysRemaining: 5,
  //       selectionCriteria: SelectionCriteria.BOTH,
  //       selected: false
  //     },
  //     {
  //       srNo: 'PR-2023-003',
  //       name: 'Unmanned Aerial Vehicle',
  //       description: 'Long-endurance UAV development',
  //       lastReview: '10 Jan 2023',
  //       closestMilestone: 'Flight Testing',
  //       daysRemaining: 45,
  //       selectionCriteria: SelectionCriteria.REVIEW_NOT_DONE,
  //       selected: false
  //     },
  //     {
  //       srNo: 'PR-2023-004',
  //       name: 'Cybersecurity Framework',
  //       description: 'Military-grade cybersecurity solution',
  //       lastReview: '05 Apr 2023',
  //       closestMilestone: 'Vulnerability Assessment',
  //       daysRemaining: 18,
  //       selectionCriteria: SelectionCriteria.NEARING_MILESTONE,
  //       selected: false
  //     },
  //     {
  //       srNo: 'PR-2023-005',
  //       name: 'Satellite Navigation',
  //       description: 'Enhanced GPS for military applications',
  //       lastReview: '18 Dec 2022',
  //       closestMilestone: 'System Integration',
  //       daysRemaining: 3,
  //       selectionCriteria: SelectionCriteria.BOTH,
  //       selected: false
  //     }
  //   ];
  // }

  private getMockReviewActionPoints(): any[] {
    return [
      {
        proposal: 'PR-2023-001',
        actionPoint: 'Finalize technical specifications document',
        dueDate: '25 May 2023',
        status: ActionPointStatus.IN_PROGRESS,
        lastUpdate: '18 May 2023'
      },
      {
        proposal: 'PR-2023-002',
        actionPoint: 'Coordinate with vendor for algorithm testing',
        dueDate: '30 May 2023',
        status: ActionPointStatus.NOT_STARTED,
        lastUpdate: '-'
      },
      {
        proposal: 'PR-2023-004',
        actionPoint: 'Review security protocols implementation',
        dueDate: '15 Jun 2023',
        status: ActionPointStatus.COMPLETED,
        lastUpdate: '10 May 2023'
      }
    ];
  }



  private getMockDashboardStats(): DashboardStats {
    return {
      ongoingProposals: 24,
      reviewsThisMonth: 8,
      pendingTasks: 16,
      directoratesInvolved: 7
    };
  }

  private getMockUpcomingReviews(): UpcomingReview[] {
    return [
      {
        srNo: 'PR-2023-002',
        name: 'AI-based Surveillance',
        description: 'AI-powered border surveillance system',
        dueDate: 'Tomorrow'
      },
      {
        srNo: 'PR-2023-001',
        name: 'Advanced Communication System',
        description: 'Development of next-gen military comm system',
        dueDate: 'In 3 days'
      },
      {
        srNo: 'PR-2023-004',
        name: 'Cybersecurity Framework',
        description: 'Military-grade cybersecurity solution',
        dueDate: 'Next week'
      }
    ];
  }
   // Dialog properties
  displayDialog: boolean = false;
  selectedProposalDetails: any | null = null;
  dialogHeader: string = 'Proposal Details';

  // ... (other existing methods)

  // View Details Method
  viewProposalDetails(proposal: Proposal): void {
    // Find detailed proposal data (in real app, this would come from API)
    // const detailedProposal = this.getDetailedProposalData(proposal.srNo);
    this.getActionPoint(proposal.proposal)
    // this.selectedProposalDetails = proposal;
    // this.dialogHeader = `Proposal Details - ${proposal.srNo}`;
    // this.displayDialog = true;
  }


  // Method to get detailed proposal data (mock data)
  private getDetailedProposalData(srNo: string): any {
    // This would typically come from your service
    const baseProposal = this.proposals.find(p => p.srNo === srNo);
    
    if (!baseProposal) {
      throw new Error(`Proposal with SR No ${srNo} not found`);
    }

    // Mock detailed data - in real app, this would come from API
    const mockDetails: { [key: string]: any } = {
      'PR-2023-001': {
        ...baseProposal,
        startDate: '2023-01-15',
        endDate: '2023-12-31',
        budget: '$2,500,000',
        status: 'In Progress',
        assignedTeam: 'Advanced Tech Division',
        progress: 65,
        risks: [
          'Technical complexity in encryption module',
          'Vendor delivery delays for hardware components',
          'Integration challenges with existing systems'
        ],
        dependencies: [
          'Hardware procurement approval',
          'Security clearance from Defense Ministry',
          'Testing environment setup'
        ],
        reviewHistory: [
          {
            date: '2023-03-15',
            type: 'Milestone Review',
            status: 'Completed',
            comments: 'Initial prototype approved. Minor adjustments needed in UI.',
            actionPoints: ['Update user interface', 'Enhance encryption protocol']
          },
          {
            date: '2023-01-30',
            type: 'Technical Review',
            status: 'Completed',
            comments: 'Technical specifications approved. Ready for development.',
            actionPoints: ['Begin development phase', 'Setup CI/CD pipeline']
          }
        ]
      },
      'PR-2023-002': {
        ...baseProposal,
        startDate: '2023-02-01',
        endDate: '2023-11-30',
        budget: '$1,800,000',
        status: 'Planning',
        assignedTeam: 'AI Research Unit',
        progress: 30,
        risks: [
          'Algorithm accuracy below target',
          'Data privacy compliance issues',
          'Hardware compatibility challenges'
        ],
        dependencies: [
          'Data acquisition approval',
          'AI model training completion',
          'Regulatory compliance clearance'
        ],
        reviewHistory: [
          {
            date: '2023-02-22',
            type: 'Initial Review',
            status: 'Completed',
            comments: 'Project scope approved. Algorithm design needs refinement.',
            actionPoints: ['Refine algorithm design', 'Prepare data acquisition plan']
          }
        ]
      },
      'PR-2023-003': {
        ...baseProposal,
        startDate: '2022-11-01',
        endDate: '2023-10-31',
        budget: '$3,200,000',
        status: 'Development',
        assignedTeam: 'Aeronautics Division',
        progress: 45,
        risks: [
          'Flight test regulatory approvals',
          'Battery life limitations',
          'Weather condition dependencies'
        ],
        dependencies: [
          'Flight test site approval',
          'Battery technology delivery',
          'Navigation system integration'
        ],
        reviewHistory: [
          {
            date: '2023-01-10',
            type: 'Design Review',
            status: 'Completed',
            comments: 'Aerodynamic design approved. Battery system needs optimization.',
            actionPoints: ['Optimize battery system', 'Finalize flight control software']
          }
        ]
      },
      'PR-2023-004': {
        ...baseProposal,
        startDate: '2023-03-01',
        endDate: '2024-02-29',
        budget: '$2,100,000',
        status: 'Testing',
        assignedTeam: 'Cyber Security Task Force',
        progress: 75,
        risks: [
          'Zero-day vulnerability discovery',
          'Performance impact on existing systems',
          'Compliance certification delays'
        ],
        dependencies: [
          'Security audit completion',
          'Penetration testing results',
          'Regulatory certification'
        ],
        reviewHistory: [
          {
            date: '2023-04-05',
            type: 'Security Review',
            status: 'Completed',
            comments: 'Initial security audit passed. Additional penetration testing required.',
            actionPoints: ['Conduct penetration testing', 'Update security protocols']
          },
          {
            date: '2023-03-15',
            type: 'Technical Review',
            status: 'Completed',
            comments: 'Architecture approved. Begin implementation phase.',
            actionPoints: ['Start implementation', 'Setup security monitoring']
          }
        ]
      },
      'PR-2023-005': {
        ...baseProposal,
        startDate: '2022-12-01',
        endDate: '2023-09-30',
        budget: '$2,800,000',
        status: 'Integration',
        assignedTeam: 'Satellite Systems Group',
        progress: 85,
        risks: [
          'Satellite signal interference',
          'Ground station compatibility issues',
          'Launch schedule delays'
        ],
        dependencies: [
          'Satellite launch schedule',
          'Ground station upgrades',
          'Integration with existing GPS infrastructure'
        ],
        reviewHistory: [
          {
            date: '2023-02-18',
            type: 'Integration Review',
            status: 'Completed',
            comments: 'System integration progressing well. Minor signal optimization needed.',
            actionPoints: ['Optimize signal processing', 'Coordinate with launch provider']
          },
          {
            date: '2022-12-15',
            type: 'Design Review',
            status: 'Completed',
            comments: 'System design approved. Begin hardware procurement.',
            actionPoints: ['Procure hardware components', 'Begin software development']
          }
        ]
      }
    };

    return mockDetails[srNo] || { ...baseProposal } as any;
  }

  // Close dialog method
  onDialogHide(): void {
    this.selectedProposalDetails = null;
    this.displayDialog = false;
  }

   private loadInternalUsers(): void {
    this.internalUsers = [
      { id: '1', name: 'Dr. Rajesh Kumar', email: 'rajesh.kumar@defense.gov', role: 'Senior Reviewer' },
      { id: '2', name: 'Col. Priya Sharma', email: 'priya.sharma@defense.gov', role: 'Technical Expert' },
      { id: '3', name: 'Dr. Amit Patel', email: 'amit.patel@defense.gov', role: 'Project Manager' },
      { id: '4', name: 'Ms. Anjali Singh', email: 'anjali.singh@defense.gov', role: 'Quality Assurance' },
      { id: '5', name: 'Mr. Vikram Mehta', email: 'vikram.mehta@defense.gov', role: 'Security Analyst' }
    ];
  }

  // Load external directorates (mock data)
  private loadExternalDirectorates(): void {
    this.externalDirectorates = [
      { id: '1', name: 'Directorate of Technical Development' },
      { id: '2', name: 'Directorate of Research & Analysis' },
      { id: '3', name: 'Directorate of Procurement' },
      { id: '4', name: 'Directorate of Quality Assurance'},
      { id: '5', name: 'Directorate of Security' },
      { id: '6', name: 'EDC', },
      { id: '7', name: 'DOI',  }
    ];
  }

  // Check if review type is internal
  isInternalReview(): boolean {
    return this.reviewType === 'Internal Review';
  }

  // Check if review type is external
  isExternalReview(): boolean {
    return this.reviewType === 'Joint Review with Nodal Directorate';
  }

  // Validate form before submission
  validateReviewSubmission(): boolean {
    // Check if proposals are selected
    if (this.selectedProposals.length === 0) {
      alert('Please select at least one proposal to proceed.');
      return false;
    }

    // Check if review date is valid
    if (!this.reviewDate) {
      alert('Please select a review date.');
      return false;
    }

    // Check if future date
    const selectedDate = new Date(this.reviewDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    if (selectedDate < today) {
      alert('Review date cannot be in the past.');
      return false;
    }

    // Check reviewers based on review type
    if (this.isInternalReview() && this.selectedUsers.length === 0) {
      alert('Please select at least one internal reviewer.');
      return false;
    }

    if (this.isExternalReview() && this.selectedDirectorates.length === 0) {
      alert('Please select at least one directorate.');
      return false;
    }

    // Validate action points
    for (let actionPoint of this.actionPoints) {
      if (!actionPoint.description?.trim()) {
        alert('Please fill in all action point descriptions.');
        return false;
      }
      if (!actionPoint.actionBy) {
        alert('Please assign all action points to a directorate.');
        return false;
      }
      if (!actionPoint.dueDate) {
        alert('Please set due dates for all action points.');
        return false;
      }
    }

    return true;
  }
   // Action Points Dialog Properties

 private loadActionPointsWithDetails(): void {
    // In real app, this would come from API
    const detailedActionPoints: ActionPointUpdate[] = [
      {
        id: 'AP-001',
        proposal: 'PR-2023-001',
        actionPoint: 'Finalize technical specifications document',
        dueDate: '2023-05-25',
        status: ActionPointStatus.IN_PROGRESS,
        priority: ActionPointPriority.HIGH,
        assignedTo: 'Technical Documentation Team',
        comments: 'Waiting for vendor input on section 3.2',
        progress: 65,
        lastUpdate: '2023-05-18',
        history: [
          {
            date: '2023-05-15',
            user: 'Dr. Rajesh Kumar',
            fromStatus: ActionPointStatus.NOT_STARTED,
            toStatus: ActionPointStatus.IN_PROGRESS,
            comments: 'Initial work started on documentation'
          },
          {
            date: '2023-05-10',
            user: 'System',
            fromStatus: ActionPointStatus.NOT_STARTED,
            toStatus: ActionPointStatus.NOT_STARTED,
            comments: 'Action point assigned'
          }
        ]
      },
      {
        id: 'AP-002',
        proposal: 'PR-2023-002',
        actionPoint: 'Coordinate with vendor for algorithm testing',
        dueDate: '2023-05-30',
        status: ActionPointStatus.NOT_STARTED,
        priority: ActionPointPriority.MEDIUM,
        assignedTo: 'Vendor Management Team',
        comments: 'Vendor availability confirmed for next week',
        progress: 0,
        lastUpdate: '2023-05-20',
        history: [
          {
            date: '2023-05-20',
            user: 'System',
            fromStatus: ActionPointStatus.NOT_STARTED,
            toStatus: ActionPointStatus.NOT_STARTED,
            comments: 'Action point assigned'
          }
        ]
      },
      {
        id: 'AP-003',
        proposal: 'PR-2023-004',
        actionPoint: 'Review security protocols implementation',
        dueDate: '2023-06-15',
        status: ActionPointStatus.COMPLETED,
        priority: ActionPointPriority.HIGH,
        assignedTo: 'Security Audit Team',
        comments: 'All security protocols implemented and tested successfully',
        progress: 100,
        lastUpdate: '2023-05-10',
        history: [
          {
            date: '2023-05-10',
            user: 'Col. Priya Sharma',
            fromStatus: ActionPointStatus.IN_PROGRESS,
            toStatus: ActionPointStatus.COMPLETED,
            comments: 'Security review completed successfully'
          },
          {
            date: '2023-05-01',
            user: 'Col. Priya Sharma',
            fromStatus: ActionPointStatus.NOT_STARTED,
            toStatus: ActionPointStatus.IN_PROGRESS,
            comments: 'Started security protocol review'
          }
        ]
      },
      {
        id: 'AP-004',
        proposal: 'PR-2023-001',
        actionPoint: 'Update encryption module documentation',
        dueDate: '2023-06-05',
        status: ActionPointStatus.ON_HOLD,
        priority: ActionPointPriority.MEDIUM,
        assignedTo: 'Technical Writing Team',
        comments: 'Waiting for security clearance on new encryption standards',
        progress: 30,
        lastUpdate: '2023-05-22',
        history: [
          {
            date: '2023-05-22',
            user: 'Ms. Anjali Singh',
            fromStatus: ActionPointStatus.IN_PROGRESS,
            toStatus: ActionPointStatus.ON_HOLD,
            comments: 'Put on hold pending security clearance'
          },
          {
            date: '2023-05-15',
            user: 'Ms. Anjali Singh',
            fromStatus: ActionPointStatus.NOT_STARTED,
            toStatus: ActionPointStatus.IN_PROGRESS,
            comments: 'Started documentation update'
          }
        ]
      },
      {
        id: 'AP-005',
        proposal: 'PR-2023-003',
        actionPoint: 'Coordinate flight test schedule with authorities',
        dueDate: '2023-06-20',
        status: ActionPointStatus.IN_PROGRESS,
        priority: ActionPointPriority.CRITICAL,
        assignedTo: 'Flight Operations Team',
        comments: 'Awaiting final approval from aviation authority',
        progress: 80,
        lastUpdate: '2023-05-25',
        history: [
          {
            date: '2023-05-25',
            user: 'Mr. Vikram Mehta',
            fromStatus: ActionPointStatus.IN_PROGRESS,
            toStatus: ActionPointStatus.IN_PROGRESS,
            comments: 'Submitted all required documents to authority'
          },
          {
            date: '2023-05-18',
            user: 'Mr. Vikram Mehta',
            fromStatus: ActionPointStatus.NOT_STARTED,
            toStatus: ActionPointStatus.IN_PROGRESS,
            comments: 'Initial coordination started'
          }
        ]
      }
    ];

    // Update the reviewActionPointsSubject with detailed data
    this.reviewActionPointsSubject.next(detailedActionPoints);
  }

  // Open update status dialog
  openUpdateStatusDialog(actionPoint: ActionPointUpdate): void {
    this.selectedActionPoint = { ...actionPoint }; // Create a copy for editing
    this.actionPointDialogHeader = `Update Action Point - ${actionPoint.id}`;
    this.displayActionPointDialog = true;
  }

  // Show success notification
  private showActionPointUpdateSuccess(): void {
    // You can use a toast service here
    alert('Action point status updated successfully!');
  }

  // Close dialog
  onActionPointDialogHide(): void {
    this.selectedActionPoint = null;
    this.displayActionPointDialog = false;
  }

  // Get overall status badge class
  getOverallStatusBadgeClass(status: string): string {
    switch (status.toLowerCase()) {
      case 'completed': return 'bg-success';
      case 'in progress': return 'bg-warning';
      case 'not started': return 'bg-secondary';
      case 'on hold': return 'bg-info';
      case 'cancelled': return 'bg-danger';
      default: return 'bg-secondary';
    }
  }

  // Close review status dialog
  onReviewStatusDialogHide(): void {
    this.selectedReviewStatus = null;
    this.displayReviewStatusDialog = false;
  }


  // Method to toggle selection
// toggleProposalSelection(proposal: any) {
//   proposal.selected = !proposal.selected;

//   // Initialize actionPoints if undefined
//   if (!proposal.actionPoints) {
//     proposal.actionPoints = [];
//   }

//   if (proposal.selected) {
//     if (!this.selectedProposals.includes(proposal)) {
//       this.selectedProposals.push(proposal);
//     }
//   } else {
//     this.selectedProposals = this.selectedProposals.filter(p => p !== proposal);
//   }
// }


  // Method to select all filtered proposals
  selectAllProposals() {
    this.selectedProposals = [...this.filteredProposals];
    this.filteredProposals.forEach(proposal => proposal.selected = true);
  }

  // Method to deselect all proposals
  deselectAllProposals() {
    this.selectedProposals = [];
    this.filteredProposals.forEach(proposal => proposal.selected = false);
  }

  // Method to get selected count
  getSelectedCount(): number {
    return this.selectedProposals.length;
  }

  // Check if all filtered proposals are selected
  areAllFilteredSelected(): boolean {
    return this.filteredProposals.length > 0 && 
           this.filteredProposals.every(p => p.selected);
  }

  areAllProposalsSelected(): boolean {
    return this.selectedProposals.length > 0 && 
           this.selectedProposals.every(p => p.selected);
  }

  toggleSelectAllProposals() {
    const allSelected = this.areAllProposalsSelected();
    this.selectedProposals.forEach(proposal => {
      proposal.selected = !allSelected;
    });
  }

  getSelectedProposalsCount(): number {
    return this.selectedProposals.filter(p => p.selected).length;
  }

  // Action Point methods
// addActionPoint(proposal: any) {
//   if (!proposal.actionPoints) {
//     proposal.actionPoints = [];
//   }

//   const newActionPoint = {
//     id: new Date().getTime(),
//     description: '',
//     actionBy: null,
//     dueDate: null,
//     comments: ''
//   };

//   proposal.actionPoints.push(newActionPoint);
// }


// // Remove action point
// removeActionPoint(proposal: any, actionPointId: number) {
//   proposal.actionPoints = proposal.actionPoints.filter(ap => ap.id !== actionPointId);
// }

// Get action points
getActionPointsForProposal(sNo: number) {
 const proposal = this.selectedProposals.find(p => Number(p.srNo) === sNo);
 if (!proposal) {
    return [];
  }
  return proposal.actionPoints || [];
}



  // removeActionPoint(actionPointId: number) {
  //   this.actionPoints = this.actionPoints.filter(ap => ap.id !== actionPointId);
  // }

  saveActionPoints() {
    // Validate action points
    const invalidActionPoints = this.actionPoints.filter(ap => 
      !ap.description.trim() || !ap.actionBy || !ap.dueDate
    );

    if (invalidActionPoints.length > 0) {
      alert('Please fill all required fields for action points (Description, Action By, Due Date)');
      return;
    }

    // Save logic here
    // console.log('Saving action points:', this.actionPoints);
    alert('Action points saved successfully!');
  }

//   submitForReview() {
//     if (this.actionPoints.length === 0) {
//       alert('Please add at least one action point before submitting');
//       return;
//     }

//     if (!this.reviewDate) {
//       alert('Please select a review date');
//       return;
//     }

//     // Submit logic here
//     console.log('Submitting for review:', {
//       reviewDate: this.reviewDate,
//       reviewType: this.reviewType,
//       proposals: this.selectedProposals,
//       actionPoints: this.actionPoints
//     });
//  const payload = 
//    this.selectedProposals.flatMap((proposal) =>
//     this.actionPoints.map((ap) => ({
//       proposal: proposal.proposal,          // proposal id
//       edc: ap.dueDate,                      // expected date of completion
//       action_point: ap.description,         // action point description
//       comment: ap.comments,                 // comment for the action
//       directorate: ap.actionBy,             // directorate id
//       status: 1                             // default status
//     }))
//   );

//     console.log("payload" , payload)
//      this.api
//       .postAPI(
//         `/idex/review/action-point/`, payload
//       )
//       .subscribe({
//         next: (res: any) => {
//         //  this.filteredProposals = res
//         this.messageService.add({
//             severity: 'success',
//             summary: 'Success',
//             detail: 'Action points Submitted',
//           });
//         },
//       });

  
//   }

    // Get selected proposals (with selection checked)
  // getSelectedProposalsWithActionPoints(): any[] {
  //   return this.selectedProposals.filter(proposal => proposal.selected);
  // }

  // Get action points for a specific proposal
  // getActionPointsForProposal(proposalSrNo: string): ActionPoint[] {
  //   return this.actionPoints.filter(ap => ap.proposalSrNo === proposalSrNo);
  // }

  // Toggle update section
  

  submitForReview() {
  const proposalsWithAP = this.selectedProposals.filter(p => p.actionPoints?.length > 0);
  if (proposalsWithAP.length === 0) {
    alert('Please add at least one action point before submitting');
    return;
  }

  const payload = proposalsWithAP.flatMap(p =>
    p.actionPoints.map(ap => ({
      proposal: p.proposal, // or p.proposal_id if that’s your field
      edc: ap.dueDate,
      action_point: ap.description,
      comment: ap.comments,
      directorate: ap.actionBy,
      status: 1
    }))
  );

  console.log('payload', payload);

  this.api.postAPI('/idex/review/action-point/', payload).subscribe({
    next: () => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Action points submitted'
      });
      // this.getActionPoint()
      this.activeTab = 'dashboard'
    }
  });
}

  
  toggleUpdateSection(actionPoint: any) {
    if (this.selectedActionPoint && this.selectedActionPoint.id === actionPoint.id) {
      this.closeUpdateSection();
    } else {
      this.selectedActionPoint = { ...actionPoint };
      this.uploadedFiles = [];
    }
  }

  closeUpdateSection() {
    this.selectedActionPoint = null;
    this.uploadedFiles = [];
  }

  // File upload methods
  onFileSelect(event: any) {
    for (let file of event.files) {
      this.uploadedFiles.push(file);
    }
  }

  onFileRemove(event: any) {
    const index = this.uploadedFiles.findIndex(f => f.name === event.file.name);
    if (index !== -1) {
      this.uploadedFiles.splice(index, 1);
    }
  }

  removeFile(file: any) {
    const index = this.uploadedFiles.findIndex(f => f.name === file.name);
    if (index !== -1) {
      this.uploadedFiles.splice(index, 1);
    }
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  // Save action point update
saveActionPointUpdate() {
    if (!this.selectedActionPoint?.status) {
      alert('Please select a status');
      return;
    }

    if (!this.selectedActionPoint.comments?.trim()) {
      alert('Please provide update comments');
      return;
    }

    // Add to history
    if (!this.selectedActionPoint.history) {
      this.selectedActionPoint.history = [];
    }

    const historyEntry: ActionPointHistory = {
      date: this.getCurrentDateString(), // Convert to string
      user: 'Current User', // Replace with actual user
      fromStatus: this.getOriginalStatus(this.selectedActionPoint.id),
      toStatus: this.selectedActionPoint.status,
      comments: this.selectedActionPoint.comments
    };

    this.selectedActionPoint.history.unshift(historyEntry);
    this.selectedActionPoint.lastUpdate = this.getCurrentDateString(); // Convert to string

    // Handle file uploads
    if (this.uploadedFiles.length > 0) {
      this.uploadFiles(this.selectedActionPoint.id);
    }

    // Update the main array
    const index = this.reviewActionPoints.findIndex(ap => ap.id === this.selectedActionPoint!.id);
    if (index !== -1) {
      this.reviewActionPoints[index] = { ...this.selectedActionPoint };
    }

    console.log('Action point updated:', this.selectedActionPoint);
    console.log('Files to upload:', this.uploadedFiles);

    alert('Action point updated successfully!');
    this.closeUpdateSection();
  }
    private getCurrentDateString(): string {
    return this.dateToString(new Date());
  }
    private dateToString(date: Date): string {
    return date.toISOString().split('T')[0];
  }

  uploadFiles(actionPointId: string) {
    // Implement your file upload logic here
    console.log(`Uploading ${this.uploadedFiles.length} files for action point ${actionPointId}`);
    // You can use a service to upload files to your backend
  }

  getOriginalStatus(actionPointId: string): ActionPointStatus {
    const original = this.reviewActionPoints.find(ap => ap.id === actionPointId);
    return original ? original.status : ActionPointStatus.NOT_STARTED;
  }

  // Existing methods
  getActionPointsCount(): number {
    return this.reviewActionPoints.length;
  }

  getOverdueActionPointsCount(): number {
    return this.reviewActionPoints.filter(ap => this.isOverdue(ap.dueDate) && ap.status !== 'COMPLETED').length;
  }

  getCompletedActionPointsCount(): number {
    return this.reviewActionPoints.filter(ap => ap.status === 'COMPLETED').length;
  }

  getInProgressActionPointsCount(): number {
    return this.reviewActionPoints.filter(ap => ap.status === 'IN_PROGRESS').length;
  }

  isOverdue(dueDate: string): boolean {
    return new Date(dueDate) < new Date();
  }

  formatDisplayDate(date: string): string {
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }

  getPriorityBadgeClass(priority: string): string {
    switch (priority) {
      case 'HIGH': return 'bg-danger';
      case 'MEDIUM': return 'bg-warning text-dark';
      case 'LOW': return 'bg-info';
      default: return 'bg-secondary';
    }
  }

  getStatusBadgeClass(status: string): string {
    switch (status) {
      case 'COMPLETED': return 'bg-success';
      case 'IN_PROGRESS': return 'bg-primary';
      case 'NOT_STARTED': return 'bg-secondary';
      case 'ON_HOLD': return 'bg-warning text-dark';
      case 'CANCELLED': return 'bg-danger';
      default: return 'bg-light text-dark';
    }
  }

  getProgressBarClass(status: string): string {
    switch (status) {
      case 'COMPLETED': return 'bg-success';
      case 'IN_PROGRESS': return 'bg-primary';
      case 'NOT_STARTED': return 'bg-secondary';
      case 'ON_HOLD': return 'bg-warning';
      case 'CANCELLED': return 'bg-danger';
      default: return 'bg-info';
    }
  }
 
  
  // File upload tracking
  uploadedFilesMap: Map<string, any[]> = new Map();

  // Toggle review details section
  toggleReviewDetails(status: any) {
    if (this.selectedReviewStatus && this.selectedReviewStatus.srNo === status.srNo) {
      this.closeReviewDetails();
    } else {
      this.selectedReviewStatus = { ...status };
      // Initialize file upload tracking for each review point
      this.selectedReviewStatus.reviewPoints.forEach((point: any) => {
        point.showFileUpload = false;
        if (!point.attachments) {
          point.attachments = [];
        }
      });
    }
  }

  closeReviewDetails() {
    this.selectedReviewStatus = null;
    this.uploadedFilesMap.clear();
  }

  // File upload methods for review points
  toggleFileUpload(point: any) {
    point.showFileUpload = !point.showFileUpload;
  }

  cancelFileUpload(point: any) {
    point.showFileUpload = false;
    this.clearUploadedFilesForPoint(point);
  }

  onReviewPointFileSelect(event: any, point: any) {
    const files = this.getUploadedFilesForPoint(point);
    for (let file of event.files) {
      files.push(file);
    }
  }

  onReviewPointFileRemove(event: any, point: any) {
    const files = this.getUploadedFilesForPoint(point);
    const index = files.findIndex(f => f.name === event.file.name);
    if (index !== -1) {
      files.splice(index, 1);
    }
  }

  getUploadedFilesForPoint(point: any): any[] {
    const key = this.getPointKey(point);
    if (!this.uploadedFilesMap.has(key)) {
      this.uploadedFilesMap.set(key, []);
    }
    return this.uploadedFilesMap.get(key)!;
  }

  removeUploadedFile(point: any, file: any) {
    const files = this.getUploadedFilesForPoint(point);
    const index = files.findIndex(f => f.name === file.name);
    if (index !== -1) {
      files.splice(index, 1);
    }
  }

  clearUploadedFilesForPoint(point: any) {
    const key = this.getPointKey(point);
    this.uploadedFilesMap.set(key, []);
  }

  getPointKey(point: any): string {
    return `${this.selectedReviewStatus.srNo}-${point.id}`;
  }

  // Upload files for a specific review point
  uploadFilesForPoint(point: any) {
    const filesToUpload = this.getUploadedFilesForPoint(point);
    
    if (filesToUpload.length === 0) {
      alert('Please select files to upload');
      return;
    }

    // Simulate file upload process
    console.log(`Uploading ${filesToUpload.length} files for review point ${point.id}`, filesToUpload);

    // Add files to point attachments
    filesToUpload.forEach(file => {
      point.attachments.push({
        name: file.name,
        size: file.size,
        type: file.type,
        uploadDate: new Date().toISOString()
      });
    });

    // Clear uploaded files and hide upload section
    this.clearUploadedFilesForPoint(point);
    point.showFileUpload = false;

    alert(`Successfully uploaded ${filesToUpload.length} file(s) for review point ${point.id}`);
  }

  // Remove attachment from review point
  removeAttachment(point: any, file: any) {
    const index = point.attachments.findIndex((f: any) => f.name === file.name);
    if (index !== -1) {
      point.attachments.splice(index, 1);
      alert('File removed successfully');
    }
  }

 getReviewPointUploadedFiles(point: any): any[] {
    const key = this.getReviewPointKey(point);
    if (!this.uploadedFilesMap.has(key)) {
      this.uploadedFilesMap.set(key, []);
    }
    return this.uploadedFilesMap.get(key)!;
  }
   getReviewPointKey(point: any): string {
    return `${this.selectedReviewStatus.srNo}-${point.id}`;
  }
    uploadReviewPointFiles(point: any) {
    const filesToUpload = this.getReviewPointUploadedFiles(point);
    
    if (filesToUpload.length === 0) {
      alert('Please select files to upload');
      return;
    }

    // Simulate file upload process
    console.log(`Uploading ${filesToUpload.length} files for review point ${point.id}`, filesToUpload);

    // Add files to point attachments
    filesToUpload.forEach(file => {
      point.attachments.push({
        name: file.name,
        size: file.size,
        type: file.type,
        uploadDate: new Date().toISOString().split('T')[0]
      });
    });

    // Update last updated date
    point.lastUpdated = new Date().toISOString().split('T')[0];

    // Clear uploaded files and hide upload section
    this.clearReviewPointUploadedFiles(point);
    point.showFileUpload = false;

    alert(`Successfully uploaded ${filesToUpload.length} file(s) for review point ${point.id}`);
  }
    clearReviewPointUploadedFiles(point: any) {
    const key = this.getReviewPointKey(point);
    this.uploadedFilesMap.set(key, []);
  }
    removeReviewPointAttachment(point: any, file: any) {
    const index = point.attachments.findIndex((f: any) => f.name === file.name);
    if (index !== -1) {
      point.attachments.splice(index, 1);
      alert('File removed successfully');
    }
  }
    getReviewPointUploadedFile(point: any): any[] {
    const key = this.getReviewPointKey(point);
    if (!this.uploadedFilesMap.has(key)) {
      this.uploadedFilesMap.set(key, []);
    }
    return this.uploadedFilesMap.get(key)!;
  }

  removeReviewPointUploadedFile(point: any, file: any) {
    const files = this.getReviewPointUploadedFiles(point);
    const index = files.findIndex(f => f.name === file.name);
    if (index !== -1) {
      files.splice(index, 1);
    }
  }
  // Summary Card Functions
  getReviewStatusTotalActionPoints(): number {
    return this.reviewStatus.reduce((total, status) => total + status.totalActionPoints, 0);
  }

  getReviewStatusOverdueCount(): number {
    return this.reviewStatus.filter(status => 
      status.reviewPoints.some(point => 
        this.isReviewPointOverdue(point.dueDate) && point.status !== 'COMPLETED'
      )
    ).length;
  }

  getReviewStatusCompletedCount(): number {
    return this.reviewStatus.filter(status => 
      status.overallStatus === 'COMPLETED'
    ).length;
  }

  getReviewStatusInProgressCount(): number {
    return this.reviewStatus.filter(status => 
      status.overallStatus === 'IN_PROGRESS'
    ).length;
  }

  // Date Formatting - handles both string and Date types
  formatReviewStatusDate(date: string | Date): string {
    if (!date) return 'N/A';
    
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    
    // Check if date is valid
    if (isNaN(dateObj.getTime())) {
      return 'Invalid Date';
    }
    
    return dateObj.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }

  // Status Badge Classes
  getReviewOverallStatusBadgeClass(status: string): string {
    switch (status) {
      case 'COMPLETED':
        return 'bg-success';
      case 'IN_PROGRESS':
        return 'bg-warning text-dark';
      case 'NOT_STARTED':
        return 'bg-secondary';
      default:
        return 'bg-info';
    }
  }

  getReviewPointStatusBadgeClass(status: string): string {
    switch (status) {
      case 'COMPLETED':
        return 'bg-success';
      case 'IN_PROGRESS':
        return 'bg-warning text-dark';
      case 'NOT_STARTED':
        return 'bg-secondary';
      default:
        return 'bg-info';
    }
  }

  // Overdue Check - handles both string and Date types
  isReviewPointOverdue(dueDate: string | Date): boolean {
    if (!dueDate) return false;
    
    const today = new Date();
    const due = typeof dueDate === 'string' ? new Date(dueDate) : dueDate;
    
    // Check if date is valid
    if (isNaN(due.getTime())) return false;
    
    today.setHours(0, 0, 0, 0);
    due.setHours(0, 0, 0, 0);
    
    return due < today;
  }

  // Review Status Selection
  toggleReviewStatusDetails(status: ReviewStatus): void {
    if (this.selectedReviewStatus && this.selectedReviewStatus.srNo === status.srNo) {
      this.selectedReviewStatus = null;
    } else {
      // Convert ReviewStatus to DetailedReviewStatus
      this.selectedReviewStatus = {
        ...status,
        reviewType: status.reviewType || 'General Review',
        overallStatus: status.overallStatus || 'NOT_STARTED',
        summary: status.summary || {
          total: status.totalActionPoints || 0,
          completed: status.completed || 0,
          inProgress: status.inProgress || 0,
          notStarted: status.pending || 0,
          pending: status.pending || 0
        },
        reviewPoints: status.reviewPoints || []
      } as DetailedReviewStatus;
      
      // Reset file upload states when switching reviews
      this.resetReviewPointFileUploads();
    }
  }

  closeReviewStatusDetails(): void {
    this.selectedReviewStatus = null;
    this.resetReviewPointFileUploads();
  }

  // File Upload Functions for Review Points
  toggleReviewPointFileUpload(point: ReviewPoint): void {
    // Close all other file upload sections
    this.resetReviewPointFileUploads();
    
    // Toggle current point
    point.showFileUpload = !point.showFileUpload;
    
    if (point.showFileUpload && !point.uploadedFiles) {
      point.uploadedFiles = [];
    }
  }

  cancelReviewPointFileUpload(point: ReviewPoint): void {
    point.showFileUpload = false;
    if (point.uploadedFiles) {
      point.uploadedFiles = [];
    }
  }

  // Helper Functions
  private resetReviewPointFileUploads(): void {
    if (this.selectedReviewStatus) {
      this.selectedReviewStatus.reviewPoints.forEach(point => {
        point.showFileUpload = false;
        if (point.uploadedFiles) {
          point.uploadedFiles = [];
        }
      });
    }
  }

  private updateReviewStatusSummary(): void {
    if (!this.selectedReviewStatus) return;

    const points = this.selectedReviewStatus.reviewPoints;
    const summary = {
      total: points.length,
      completed: points.filter(p => p.status === 'COMPLETED').length,
      inProgress: points.filter(p => p.status === 'IN_PROGRESS').length,
      notStarted: points.filter(p => p.status === 'NOT_STARTED').length,
      pending: points.filter(p => p.status === 'NOT_STARTED' || p.status === 'IN_PROGRESS').length
    };

    this.selectedReviewStatus.summary = summary;
    this.selectedReviewStatus.completed = summary.completed;
    this.selectedReviewStatus.inProgress = summary.inProgress;
    this.selectedReviewStatus.pending = summary.pending;
    this.selectedReviewStatus.totalActionPoints = summary.total;

    // Update overall status
    if (summary.completed === summary.total) {
      this.selectedReviewStatus.overallStatus = 'COMPLETED';
    } else if (summary.completed > 0 || summary.inProgress > 0) {
      this.selectedReviewStatus.overallStatus = 'IN_PROGRESS';
    } else {
      this.selectedReviewStatus.overallStatus = 'NOT_STARTED';
    }
  }

  // Mock Data Loader - Updated to match your data structure
  private loadReviewStatusData(): void {
    // Mock data that matches your interface
    this.reviewStatus = [
      {
        srNo: 'SR-2024-001',
        proposalName: 'Q1 Marketing Campaign Proposal',
        reviewDate: '2024-01-15', // Can be string or Date
        reviewType: 'Initial Review',
        overallStatus: 'IN_PROGRESS',
        totalActionPoints: 8,
        completed: 3,
        inProgress: 3,
        pending: 2,
        summary: {
          total: 8,
          completed: 3,
          inProgress: 3,
          notStarted: 2,
          pending: 5
        },
        reviewPoints: [
          {
            id: 'RP-001',
            category: 'Budget',
            description: 'Review marketing budget allocation',
            assignedTo: 'John Smith',
            dueDate: '2024-01-20', // Can be string or Date
            status: 'COMPLETED',
            lastUpdated: '2024-01-18', // Can be string or Date
            attachments: [
              { 
                name: 'budget-analysis.pdf', 
                size: 2048576, 
                type: 'application/pdf', 
                uploadDate: '2024-01-18' 
              }
            ],
            uploadedFiles: [],
            showFileUpload: false
          },
          {
            id: 'RP-002',
            category: 'Timeline',
            description: 'Verify project timeline feasibility',
            comments: 'Need to align with product launch',
            assignedTo: 'Sarah Johnson',
            dueDate: '2024-01-25',
            status: 'IN_PROGRESS',
            lastUpdated: '2024-01-19',
            attachments: [],
            uploadedFiles: [],
            showFileUpload: false
          },
          {
            id: 'RP-003',
            category: 'Legal',
            description: 'Compliance review for advertising claims',
            assignedTo: 'Mike Wilson',
            dueDate: '2024-01-22',
            status: 'NOT_STARTED',
            lastUpdated: '2024-01-15',
            attachments: [],
            uploadedFiles: [],
            showFileUpload: false
          }
        ]
      },
      {
        srNo: 'SR-2024-002',
        proposalName: 'New Product Development Phase 2',
        reviewDate: new Date('2024-01-10'), // Can be Date object
        reviewType: 'Progress Review',
        overallStatus: 'COMPLETED',
        totalActionPoints: 5,
        completed: 5,
        inProgress: 0,
        pending: 0,
        summary: {
          total: 5,
          completed: 5,
          inProgress: 0,
          notStarted: 0,
          pending: 0
        },
        reviewPoints: [
          {
            id: 'RP-004',
            category: 'Technical',
            description: 'Review prototype testing results',
            assignedTo: 'Emily Chen',
            dueDate: new Date('2024-01-15'),
            status: 'COMPLETED',
            lastUpdated: new Date('2024-01-14'),
            attachments: [
              { 
                name: 'test-results.xlsx', 
                size: 512000, 
                type: 'application/vnd.ms-excel', 
                uploadDate: new Date('2024-01-14') 
              }
            ],
            uploadedFiles: [],
            showFileUpload: false
          }
        ]
      }
    ] as ReviewStatus[];
  }
getReviewList() {

  this.api
    .getAPI(`/idex/review/list/`)
    .subscribe({
      next: (res: any) => {

        this.filteredProposals = res.map((p: any) => ({
          ...p,
          proposalId: p.proposal,
          actionPoints: p.actionPoints || []
        }));

        this.totalRecords = this.filteredProposals.length;

        // ⭐ QUERY PARAM LOGIC
        if (this.proposalId) {

          const proposal = this.filteredProposals.find(
            (p: any) => p.proposalId == this.proposalId
          );

          if (proposal) {

            // proposal select
            proposal.selected = true;

            this.selectedProposals = [proposal];

            // direct review tab open
            this.activeTab = 'send';

            // action point section open
            this.selectedProposalForActionPoints = proposal;
            this.showActionPoints = true;

            // action points API
            this.getActionPoints(this.proposalId);

          }

        }

      },
    });

}
getActionPoint(proposalId: number) {
  this.api.getAPI(`/idex/review/action-point/?proposal=${proposalId}`).subscribe({
    next: (res: any[]) => {
      if (res && res.length > 0) {
        // Common proposal details
        this.selectedProposalDetails = {
          proposal_name: res[0].proposal_name,
          challenge: res[0].challenge,
          scheme_name: res[0].scheme_name,
          status: res[0].status,
          assigned_date: res[0].assigned_date,
          created_on: res[0].created_on,
        };

        // All action points for that proposal
        this.actionPointList = res
          .filter(item => item.action_point || item.comment)
          .map(item => ({
            edc: item.edc,
            action_point: item.action_point,
            comment: item.comment,
            directorate: item.directorate,
            flag: item.flag,
          }));

        // this.displayDialog = true;
      }
    },
    error: (err) => {
      console.error('Failed to fetch action points', err);
    },
  });
}


    getUnit() {
     let currentUnitId  = sessionStorage.getItem('unit_id');
    const sub = this.api.getAPI('/master/units/').subscribe((res: any) => {
      this.directorates = res.data;
    })
    this.subscriptions.add(sub);
  }
  closeProposalDetails(){
    this.selectedProposalDetails = null
  }
toggleProposalSelection(proposal: any) {
  proposal.selected = !proposal.selected;

  if (proposal.selected) {
    console.log("Selected Proposal:", proposal);
    console.log("Proposal ID:", proposal.proposal);
     this.getActionPoints(proposal.proposal);

    if (!proposal.actionPoints) proposal.actionPoints = [];
    if (!this.selectedProposals.includes(proposal)) {
      this.selectedProposals.push(proposal);
    }
  } else {
    this.selectedProposals = this.selectedProposals.filter(p => p !== proposal);
  }
}


addActionPoint(proposal: any) {
  if (!proposal.actionPoints) proposal.actionPoints = [];

  const newActionPoint = {
    id: new Date().getTime(),
    description: '',
    actionBy: null,
    dueDate: null,
    comments: ''
  };

  proposal.actionPoints.push(newActionPoint);
}
generateActionRows(count: any, proposal: any) {

  const num = Number(count);

  proposal.actionPoints = [];

  for (let i = 0; i < num; i++) {
    proposal.actionPoints.push({
      id: new Date().getTime() + i,
      description: '',
      actionBy: null,
      dueDate: null,
      comments: ''
    });
  }

}

removeActionPoint(proposal: any, actionPointId: number) {
  proposal.actionPoints = proposal.actionPoints.filter(ap => ap.id !== actionPointId);
}

getSelectedProposalsWithActionPoints() {
  return this.selectedProposals.filter(p => p.actionPoints && p.actionPoints.length > 0);
}

// (Optional) If you want total count across all proposals
// getTotalActionPointsCount(): number {
//   return this.selectedProposals.reduce(
//     (sum, proposal) => sum + (proposal.actionPoints?.length || 0), 
//     0
//   );
// }
getTotalActionPointsCount(): number {
  return this.selectedProposals.reduce(
    (sum, p) => sum + (p.actionPoints ? p.actionPoints.length : 0),
    0
  );
}
backToMonitoring(): void {
  this.location.back();
}
getActionPoints(proposalId: any) {

  const url = `/idex/review/action-point/?proposal=${proposalId}`;

  this.api.getAPI(url).subscribe((res: any) => {
    console.log("Action Points Response", res);

    this.reviewActionPoints = res?.data || res || [];

  });

}
toggleActionPoints(proposal: any) {

  if (this.showActionPoints && this.selectedProposalForActionPoints === proposal) {

    this.showActionPoints = false;
    this.selectedProposalForActionPoints = null;

  } else {

    this.selectedProposalForActionPoints = proposal;
    this.showActionPoints = true;

    // 🔥 send proposal id
    this.getActionPoints(proposal.proposal);

  }

}

showActionPoints = false;
selectedProposalForActionPoints: any;

openActionPoints(proposal: any) {
  this.selectedProposalForActionPoints = proposal;
  this.showActionPoints = true;
}

}
export interface ActionPoint {
  description: string;
  dueDate: string;
  comments: string;
}

export interface Proposal {
  id: number;
  proposal_name: string;
  scheme_name: string;

  showActionPoints?: boolean;
}
export interface Proposal {
  actionPoints: any[];
  proposal: any;
  srNo: string;
  proposal_name: string;
  scheme_name: string;
  description: string;
  lastReview: string;
  closestMilestone: string;
  daysRemaining: number;
  selectionCriteria: SelectionCriteria;
  selected?: boolean;
}

export interface Directorate {
  id: string;
  name: string;
}

export interface ActionPoint {
  id: number;
  proposalId: string;  // Required property
  proposalSrNo: string;
  proposalName: string;
  description: string;
  actionBy: string;
  dueDate: string;
  comments: string;
}

export interface ReviewActionPoint {
  id: string;
  proposal: string;
  actionPoint: string;
  dueDate: string;
  status: ActionPointStatus;
  priority: ActionPointPriority;
  assignedTo: string;
  comments: string;
  progress: number;
  lastUpdate: string;
  history: ActionPointHistory[];
}



export interface DashboardStats {
  ongoingProposals: number;
  reviewsThisMonth: number;
  pendingTasks: number;
  directoratesInvolved: number;
}

export interface UpcomingReview {
  srNo: string;
  name: string;
  description: string;
  dueDate: string;
}

export enum SelectionCriteria {
  NEARING_MILESTONE = 'Nearing Milestone',
  REVIEW_NOT_DONE = 'Review Not Done',
  BOTH = 'Both'
}
export enum ActionPointStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  ON_HOLD = 'ON_HOLD',
  CANCELLED = 'CANCELLED'
}

export enum ReviewType {
  INTERNAL_REVIEW = 'Internal Review',
  JOINT_REVIEW = 'Joint Review with Nodal Directorate'
}

export interface User {
  id: string;
  name: string;
  email: string;
  role: string;
}

export interface Directorate {
  id: string;
  name: string;
  // contactPerson: string;
  // email: string;
}
export enum ActionPointPriority {
  LOW = 'Low',
  MEDIUM = 'Medium',
  HIGH = 'High',
  CRITICAL = 'Critical'
}
export interface ActionPointUpdate {
  id: string;
  proposal: string;
  actionPoint: string;
  dueDate: string;
  status: ActionPointStatus;
  priority: ActionPointPriority;
  assignedTo: string;
  comments: string;
  progress: number;
  lastUpdate: string;
  history: ActionPointHistory[];
}
export interface ActionPointHistory {
  date: string;
  user: string;
  fromStatus: ActionPointStatus;
  toStatus: ActionPointStatus;
  comments: string;
}


interface ReviewStatus {
  srNo: string;
  proposalName: string;
  reviewDate: string | Date; // Updated to accept both string and Date
  reviewType: string;
  overallStatus: string;
  totalActionPoints: number;
  completed: number;
  inProgress: number;
  pending: number;
  summary: {
    total: number;
    completed: number;
    inProgress: number;
    notStarted: number;
    pending: number; // Added missing property
  };
  reviewPoints: ReviewPoint[];
}

interface ReviewPoint {
  id: string;
  category: string;
  description: string;
  comments?: string;
  assignedTo: string;
  dueDate: string | Date; // Updated to accept both string and Date
  status: 'NOT_STARTED' | 'IN_PROGRESS' | 'COMPLETED';
  lastUpdated: string | Date; // Updated to accept both string and Date
  attachments: FileAttachment[];
  // Added optional properties for file upload
  uploadedFiles?: File[];
  showFileUpload?: boolean;
}

interface FileAttachment {
  name: string;
  size: number;
  type: string;
  uploadDate: string | Date; // Updated to accept both string and Date
}

// Main interface that matches your existing data structure
interface DetailedReviewStatus {
  srNo: string;
  proposalName: string;
  reviewDate: string | Date;
  reviewType: string;
  overallStatus: string;
  totalActionPoints: number;
  completed: number;
  inProgress: number;
  pending: number;
  summary: {
    total: number;
    completed: number;
    inProgress: number;
    notStarted: number;
    pending: number;
  };
  reviewPoints: ReviewPoint[];
}